import React, { PureComponent } from 'react'
import { Row, Col } from 'react-bootstrap'

class Tab4 extends PureComponent {
  render () {
    return (
      <Col sm={12}>
        <Row>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">V.S.B:</span>
              <span className="second">V.S.B</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Marca:</span>
              <span className="second">Marca</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Familia:</span>
              <span className="second">Familia</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Modelo:</span>
              <span className="second">Modelo</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Acabado:</span>
              <span className="second">Acabado</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Color:</span>
              <span className="second">Color</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Combustible:</span>
              <span className="second">Combustible</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Chasis:</span>
              <span className="second">Chasis</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Nº Pedido:</span>
              <span className="second">Nº Pedido</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Matricula:</span>
              <span className="second">Matricula</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Fecha matriculación:</span>
              <span className="second">Fecha matriculación</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">KM:</span>
              <span className="second">KM</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Estado general:</span>
              <span className="second">Estado general</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Procedencia:</span>
              <span className="second">Procedencia</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Fecha tasación:</span>
              <span className="second">Fecha tasación</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Fecha cad. tasación:</span>
              <span className="second">Fecha cad. tasación</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Fecha ITV:</span>
              <span className="second">Fecha ITV</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Importe tasación:</span>
              <span className="second">Importe tasación</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Daños:</span>
              <span className="second">Daños</span>
            </div>
          </Col>
        </Row>
      </Col>
    )
  }
}

export default Tab4
